/* Afroyla LAST PIECES — sticky checkout bar: "2 items · $49.90 / Price held till 11:59 PM ET. Stock isn't held." +
 * "Checkout →". Shows whenever the cart has items while the sale is live. Repaints from 'alp:added' (cart from the
 * Horizon module, no extra GET) or Horizon 'cart:update' (drawer qty change/remove → debounced GET /cart.js).
 * Cloned from afroyla-fall-clearance-sticky-checkout-bar.js minus the personal 60-min timer. Needs window.ALP. */
(function () {
  var A = window.ALP;
  if (!A) return;
  var root = A.root;
  var bar = root.querySelector('[data-alp-bar]');
  if (!bar) return;
  var tEl = bar.querySelector('[data-alp-bar-t]');
  var timer = null;

  function paint(cart) {
    if (!cart) return;
    var n = cart.item_count || 0;
    bar.hidden = n < 1 || A.phase() !== 'live';
    root.classList.toggle('has-bar', !bar.hidden);
    if (bar.hidden) return;
    tEl.innerHTML = '<b>' + n + (n === 1 ? ' item' : ' items') + ' · ' + A.money((cart.total_price || 0) / 100) + '</b>' +
      '<small>Price held till 11:59 PM ET. Stock isn&#39;t held.</small>';
  }
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(paint).catch(function () {});
    }, 150);
  }
  root.addEventListener('alp:added', function (e) { if (e.detail && e.detail.cart) paint(e.detail.cart); else refresh(); });
  root.addEventListener('alp:ended', function () { bar.hidden = true; root.classList.remove('has-bar'); });
  document.addEventListener('cart:update', refresh);
  refresh();
})();
